module.exports = __webpack_public_path__ + "img/pin_taxi_from@3x.d6e7e872.png";